<template>
	<div class="sidebar" :class="{show:show}">
		<div class="sidebar-container">
			<div class="sidebar-title" :title="title">{{title}}</div>
			<div class="sidebar-list">
				<div v-for="(item,index) in list" :key="index" :class="{act:index===current}" class="sidebar-item" @click="setCurrent(index)">
					<span>{{item.name}}</span>
				</div>
			</div>
		</div>
		<div class="sidebar-copyright">copyright @ <a href="https://www.dcloud.io/" target="_blank">DCloud.io</a></div>
	</div>
</template>

<script>
	export default {
		name: 'SideBar',
		props: {
			title: {
				type: String,
				default () {
					return ''
				}
			},
			list: {
				type: Array,
				default () {
					return []
				}
			},
			show: {
				type: Boolean,
				default () {
					return false
				}
			},
			current: {
				type: Number,
				default () {
					return 0
				}
			}
		},
		methods: {
			setCurrent(index) {
				this.$emit("setCurrent", index);
			}
		}
	}
</script>

<style scoped>
	.sidebar {
		position: absolute;
		top: 60px;
		left: 0;
		bottom: 0;
		width: 350px;
		background-color: #1D1D1D;
		display: none;
	}


	.sidebar.show {
		display: block;
	}

	.sidebar-container {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 40px;
		padding: 20px;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.sidebar-container::-webkit-scrollbar {
		width: 10px;
		border-radius: 10px;
		background: #333333;
	}

	.sidebar-container::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #666666;
	}

	.sidebar-title {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		color: #999999;
	}

	.sidebar-list {
		padding: 20px 0px;
	}

	.sidebar-item {
		display: block;
		font-size: 14px;
		line-height: 22px;
		padding: 4px 0px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #666666;
		cursor: pointer;
	}

	.sidebar-item.act {
		color: #42b983;
	}

	.sidebar-copyright {
		position: absolute;
		left: 0;
		bottom: 0px;
		width: 100%;
		height: 40px;
		color: #666666;
		font-size: 12px;
		line-height: 40px;
		text-align: center;
		letter-spacing: 0.5px;
	}
	
	.sidebar-copyright a{
		color: #666666;
	}
</style>
